import { initializeApp, getApps, getApp } from "firebase/app"; // Thêm getApps, getApp
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyB46eP6G2lAkT15HaGWbkjMSTpBdrJnW5c",
  authDomain: "habakome-6d2ee.firebaseapp.com",
  projectId: "habakome-6d2ee",
  storageBucket: "habakome-6d2ee.firebasestorage.app",
  messagingSenderId: "156082327114",
  appId: "1:156082327114:web:c638d4365239f98a8ee0b3",
  measurementId: "G-7080GERZJ6",
  databaseURL:
    "https://habakome-6d2ee-default-rtdb.asia-southeast1.firebasedatabase.app/",
};

// Khởi tạo Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Khởi tạo các dịch vụ
export const db = getDatabase(app); // Database lưu trữ chữ
export const storage = getStorage(app); // Kho lưu trữ ảnh (5GB)
export const auth = getAuth(app); // Xác thực người dùng
export const realDB = getDatabase(app);
